import { useState } from 'react';

export interface AssignConfirmationState {
  isConfirmationOpen: boolean;
  onOpenConfirmation: () => void;
  onCancelConfirmation: () => void;
}

export const useAssignConfirmationState = (): AssignConfirmationState => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const onOpenConfirmation = (): void => {
    setIsConfirmationOpen(true);
  };

  const onCancelConfirmation = (): void => {
    setIsConfirmationOpen(false);
  };

  return {
    isConfirmationOpen,
    onOpenConfirmation,
    onCancelConfirmation,
  };
};